import { render } from "./HomeFaderSlide.vue?vue&type=template&id=f46fa08a&scoped=true"
import script from "./HomeFaderSlide.vue?vue&type=script&lang=js"
export * from "./HomeFaderSlide.vue?vue&type=script&lang=js"

import "./HomeFaderSlide.vue?vue&type=style&index=0&id=f46fa08a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46fa08a"]])

export default __exports__